import { post, get } from "./divertidogsApiUtils";
import Cookies from 'js-cookie';
import { JWT_DIVERTIDOGS_COOKIE } from './divertidogsApiUtils';
import { useQuery } from "@tanstack/react-query";
import AuthError from "./AuthError";

export interface RespuestaAuth {
    token: string;
}

export interface RespuestaOAuthExchange {
    token: string;
    tokenType: string;
    expiresIn: number;
}

interface Credenciales {
    email: string,
    clave: string
}

export interface Usuario {
    email: string,
    clave: string
}

export interface RolUsuario {
    id: string;
    codigo: string;
    categoria: string;
    descripcion: string;
}

export interface RespuestaUsuario {
    id: string,
    email: string,
    grupoUsuario: string,
    roles: Array<RolUsuario>
}

export const guardarResultadoAuth = (respuestaAuth?: RespuestaAuth) => {
    if(respuestaAuth){
        Cookies.set(JWT_DIVERTIDOGS_COOKIE, respuestaAuth.token);
    }
}

export const limpiarInformacionAuth = () => {
    Cookies.remove(JWT_DIVERTIDOGS_COOKIE);
}

export const login  = async (credenciales: Credenciales): Promise<RespuestaAuth| undefined> => {
    return post<Credenciales, RespuestaAuth | undefined>('auth/login', credenciales, false);
}

export const iniciarSesion = async (credenciales: Credenciales) => {
    const respuestaLogin = await login(credenciales);
    guardarResultadoAuth(respuestaLogin);
}

export const intercambiarCodigoOAuth = async (code: string): Promise<RespuestaOAuthExchange> => {
    return post<{ code: string }, RespuestaOAuthExchange>('auth/oauth2/exchange', { code }, false);
}

export const crearUsuario = async (usuario: Usuario): Promise<RespuestaUsuario| undefined> => {
    return post<Usuario, RespuestaUsuario | undefined>('auth/registrar', usuario, false);
}

export const infoUsuario = async  (): Promise<RespuestaUsuario| undefined> => {
    return get<RespuestaUsuario | undefined>('usuarios/yo');
}

export const authEsValido = async (): Promise<boolean> => {
    try {
        await infoUsuario();
        return true;
    } catch (error){
        return false;
    }
}

export const QUERY_USUARIO_ACTUAL = "usuario_actual";

export const useUsuarioActual = () => {
    return useQuery({
        queryKey: [QUERY_USUARIO_ACTUAL],
        queryFn: async () => {
            const usuario = await infoUsuario();
            return usuario || null;
        },
        staleTime: 5 * 60 * 1000,
        retry: (failureCount, error) =>
          failureCount < 3 && !(error instanceof AuthError),
    });
};